module.exports = __webpack_public_path__ + "static/media/lp_key.d7c2ea56.svg";